import {createToast} from '../helpers/toast-builder'
import {addReducerParametersToError} from "../middleware/middleware-error-handler";
import {createLoadingScreen} from "../helpers/loading-screen-builder";
import {getTranslation} from "../helpers/get-translation";
import LOGIN_EMAIL_ACTIONS from "../constants/LOGIN_EMAIL_ACTIONS";

export const CHANGE_SCREEN = "CHANGE_SCREEN";
export const SET_CURRENT_RIDDLE_RANGE = "SET_CURRENT_RIDDLE_RANGE";
export const RETURN_TO_LAST_SCREEN = "RETURN_TO_LAST_SCREEN";
export const SET_ACTIVE_RIDDLE = "SET_ACTIVE_RIDDLE";
export const ADD_LOADING_SCREEN = "ADD_LOADING_SCREEN";
export const REMOVE_LOADING_SCREEN = "REMOVE_LOADING_SCREEN";
export const UPDATE_SCROLL_POSITION = "UPDATE_SCROLL_POSITION";
export const ADD_MODAL_WINDOW = "ADD_MODAL_WINDOW";
export const REMOVE_MODAL_WINDOW = "REMOVE_MODAL_WINDOW";
export const ADD_TOAST = "ADD_TOAST";
export const REMOVE_TOAST = "REMOVE_TOAST";
export const DECREMENT_ACTIVE_RIDDLE_POINTS = "DECREMENT_ACTIVE_RIDDLE_POINTS";
export const REMOVE_MODAL_WINDOW_AT_INDEXES = "REMOVE_MODAL_WINDOW_AT_INDEXES";
export const RESET_SCREEN_AFTER_LOGOUT = "RESET_SCREEN_AFTER_LOGOUT";
export const UPDATE_ACTIVE_LOGO_WITH_HINT = "UPDATE_ACTIVE_LOGO_WITH_HINT";


/* Wszystkie ekrany w aplikacji */
export const MAIN_SCREEN = getTranslation("MAIN_SCREEN_url"); //ekran główny
export const PLAY_SCREEN = getTranslation("PLAY_SCREEN_url"); //ekran z listą poziomów
export const LOGOS_SCREEN = getTranslation("LOGOS_SCREEN_url"); //ekran z logotypami
export const GAME_SCREEN = getTranslation("GAME_SCREEN_url"); //ekran odgadywania zagadki
export const SETTINGS_SCREEN = getTranslation("SETTINGS_SCREEN_url");
export const STATISTICS_SCREEN = getTranslation("STATISTICS_SCREEN_url");
export const EXTRA_SCREEN = getTranslation("EXTRA_SCREEN_url"); //ekran listy extra poziomów
export const HINTS_SCREEN = getTranslation("HINTS_SCREEN_url");
export const RANKING_SCREEN = getTranslation("RANKING_SCREEN_url");
export const LOGIN_SCREEN = getTranslation("LOGIN_SCREEN_url");
export const LOGIN_EMAIL_SCREEN = LOGIN_EMAIL_ACTIONS.LOGIN;
export const REGISTER_EMAIL_SCREEN = LOGIN_EMAIL_ACTIONS.REGISTER;
export const RESET_EMAIL_SCREEN = LOGIN_EMAIL_ACTIONS.RESET;

export function getScreenTitleKey(screen) {
	switch (screen) {
		case PLAY_SCREEN: return "PLAY_SCREEN_title";
		case LOGOS_SCREEN: return "LOGOS_SCREEN_title";
		case SETTINGS_SCREEN: return "SETTINGS_SCREEN_title";
		case STATISTICS_SCREEN: return "STATISTICS_SCREEN_title";
		case EXTRA_SCREEN: return "EXTRA_SCREEN_title";
		case HINTS_SCREEN: return "HINTS_SCREEN_title";
		case RANKING_SCREEN: return "RANKING_SCREEN_title";
		case LOGIN_SCREEN: return "LOGIN_SCREEN_title";
		case LOGIN_EMAIL_SCREEN: return "LOGIN_EMAIL_SCREEN_title";
		case REGISTER_EMAIL_SCREEN: return "REGISTER_EMAIL_SCREEN_title";
		case RESET_EMAIL_SCREEN: return "RESET_EMAIL_SCREEN_title";
		default: throw Error(`getScreenTitleKey screen: ${screen} not found`)
	}
}

/* Wszystkie synchroniczne action creators */

/**
 * Wywoływane w routerze zależnie od ścieżki url
 * @param screen - nazwa ekranu
 */
export function changeScreen(screen) {
	return {
		type: CHANGE_SCREEN,
		payload: { screen }
	};
}

/**
 * @param loadingId - używane do tłumaczenia i do usuwania ekranu
 * @param excludedScreens - wykluczone ekrany na których nie pokazuje się loading screen
 */
export function addLoadingScreen(loadingId, excludedScreens) {
	const loadingScreen = createLoadingScreen(loadingId, excludedScreens);
	return {
		type: ADD_LOADING_SCREEN,
		payload: {
			loadingScreen
		}
	};
}

/**
 * @param loadingId - identyfikator, po którym usuwamy ekran
 */
export function removeLoadingScreen(loadingId) {
	return {
		type: REMOVE_LOADING_SCREEN,
		payload: {
			loadingId,
		}
	};
}

/**
 * @param modal - obiekty stworzony poprzez helpers/modal-builder
 */
export function addModalWindow(modal){
	return {
		type: ADD_MODAL_WINDOW,
		payload: {
			modal
		}
	};
}

/**
 * usuwa modal z samego wierzchu
 */
export function removeModalWindow() {
	return {
		type: REMOVE_MODAL_WINDOW
	}
}

/**
 * @param indexList - lista z indeksami modali do usunięcia
 */
export function removeModalWindowAtIndexes(indexList){
	return {
		type: REMOVE_MODAL_WINDOW_AT_INDEXES,
		payload:{
			indexList
		}
	}
}

/**
 * @param key - klucz stringa z tlumaczen
 * @param timeout
 * @param args - argumenty do stringu
 */
export function addToast(key, timeout = 5000, args = []){
	const toast = createToast(key, timeout, args);
	return {
		type: ADD_TOAST,
		payload: {
			toast
		}
	};
}

/**
 * @param id - jest to identyfikator (auto-increment) który jest nadawany w recuderze, case ADD_TOAST
 */
export function removeToast(id) {
	return {
		type: REMOVE_TOAST,
		payload: {
			id
		}
	}
}

/**
 * Wywoływane na modalu odblokowania poziomu, w play-screen (wybranie poziomu)
 * @param riddleRange - logosFrom-LogosTo w wybranym poziomie
 * @returns {{type: string, payload: *}}
 */
export function setCurrentRiddleRange(riddleRange) {
	return {
		type: SET_CURRENT_RIDDLE_RANGE,
		payload: riddleRange
	};
}

/**
 * Odejmuje punkt z aktulanie wybranego riddle (ekran gry)
 *
 * @param amount
 */
export function decrementActiveRiddlePoints(amount) {
	return {
		type: DECREMENT_ACTIVE_RIDDLE_POINTS,
		payload: {
			amount
		}
	};
}

/**
 * Wywoływane po wybraniu riddle z ekranu lóg, lub przy poprawnym odgadnięciu riddle?
 * @param riddle - obiekt pojedyńczej zagadki z bazy danych
 * @param index - położenie w aktualnym poziomie
 */
export function setActiveRiddle(riddle, index) {
	return {
		type: SET_ACTIVE_RIDDLE,
		payload: {
			riddle,
			index
		}
	};
}

/**
 * Wywoływana przy wyjściu z ekranu gdzie ma być zapamiętana pozycja scrolla
 * play-screen, extra-level-screen, logos-screen
 *
 * @param position - odległość w pikselach od góry
 * @param screen - ekran w którym ma być zapamiętana pozycja
 */
export function updateScrollPosition(position, screen) {
	return {
		type: UPDATE_SCROLL_POSITION,
		payload: {
			position,
			screen,
		}
	};
}

/**
 * Wywoływana po wylogowaniu się, służy do przywrócenia ustawień defaultowych, oprócz ekranu na którym się znajdujemy
 */
export function resetScreenAfterLogout() {
	return {
		type: RESET_SCREEN_AFTER_LOGOUT,
	};
}

/**
 * Wywoływana po pomyślnym zakupie hintu
 */
export function updateActiveLogoWithHint(hintKey, value){
	return {
		type: UPDATE_ACTIVE_LOGO_WITH_HINT,
		payload: {
			hintKey,
			value
		}
	}
}

const defaultState = {
	loadingList: [],
	// loadingList: ["No elo"],
	modalList: [],
	// modalList: [
	// 	wheelModal()
	// 	errorModal({message: "error1"}),
	// 	errorModal({message: "error2"}),
	// 	unlockLevelModal({levelName: 2}),
	// 	unlockExtraLevelModal({levelName: 'food'}),
	// 	confirmDeleteModal()
	// ],

	toastList: [],
	// toastList: [createToast('Testowy toast', 500000)],
	toastId: 0,

	scrollPositions: {
		'classic': 0,
		'logoList': 0,
	},
	screen: "main",
	currentRiddleRange: "1-30", //przedzial logosFrom-logosTo
	activeLogo: {}, //dane aktywnego logo
	activeLogoIndex: 0, //index loga w przedziale
};


export default function(state = defaultState, action) {
	try{
		switch (action.type) {
			case CHANGE_SCREEN:
				return Object.assign(
					{},
					state,
					{ screen: action.payload.screen || "main" },
					// { history: [...history, screen] }
				);
			case ADD_LOADING_SCREEN: {
				const newLoadingScreen = action.payload.loadingScreen;
				const loadingId = newLoadingScreen.loadingId;

				const currentLoadingList = state.loadingList;

				//Sprawdzamy czy dane Id już jest w liście
				const screenAlreadyExists = currentLoadingList.some(loadingScreen => {
					return loadingScreen.loadingId === loadingId
				});

				let newLoadingList;
				if (screenAlreadyExists) {
					newLoadingList = currentLoadingList;
				} else {
					newLoadingList = [...currentLoadingList, newLoadingScreen];
				}

				return Object.assign({}, state, { loadingList: newLoadingList });
			}

			case REMOVE_LOADING_SCREEN: {
				const loadingId = action.payload.loadingId;

				const currentLoadingList = state.loadingList;
				//Usuwamy z listy screen z podanym Id
				let newLoadingList = currentLoadingList.filter(loadingScreen => (loadingScreen.loadingId !== loadingId));

				return Object.assign({}, state, { loadingList: newLoadingList });
			}

			case UPDATE_SCROLL_POSITION:{
				const { position,  screen } = action.payload;
				// debugger;
				const currentScrollPositions = Object.assign({}, state.scrollPositions, { [screen]: position });
				return Object.assign({}, state, { scrollPositions: currentScrollPositions })
			}

			case SET_CURRENT_RIDDLE_RANGE: {
				return Object.assign({}, state, {currentRiddleRange: action.payload});
			}

			case RETURN_TO_LAST_SCREEN: {
				const lastScreen = "main";
				// const newHistory = history.slice(0, history.length - 1);
				return Object.assign(
					{},
					state,
					{screen: lastScreen},
					// { history: newHistory }
				);
			}

			case ADD_MODAL_WINDOW:{
				const currentModalList = state.modalList;
				const isAlreadyInList = currentModalList.some(element => element.message === action.payload.modal.message);
				if(isAlreadyInList){
					return state
				} else {
					const newModalList = [...currentModalList, action.payload.modal];
					return Object.assign({}, state, { modalList: newModalList });
				}
			}

			case REMOVE_MODAL_WINDOW: {
				const currentModalList = state.modalList;
				const newModalList = currentModalList.slice(0, -1);

				return Object.assign({}, state, { modalList: newModalList });
			}

			case REMOVE_MODAL_WINDOW_AT_INDEXES:{
				const currentModalList = state.modalList;
				const indexesToRemove = action.payload.indexList;

				const newModalList = currentModalList.filter((element, index) => {
					return indexesToRemove.indexOf(index) === -1
				} );

				return Object.assign({}, state, { modalList: newModalList });
			}

			case ADD_TOAST:{
				const currentToastList = state.toastList;
				const newToast = action.payload.toast;
				newToast.id = state.toastId + 1;
				if(!newToast.timeout){
					newToast.timeout = 2000;
				}
				const newToastList = [...currentToastList, newToast];

				return Object.assign({}, state, { toastList: newToastList , toastId: state.toastId + 1});
			}

			case REMOVE_TOAST:{
				const currentToastList = state.toastList;
				const idToRemove = action.payload.id;
				const newToastList = currentToastList.filter(toast => toast.id !== idToRemove);

				return Object.assign({}, state, { toastList: newToastList });
			}

			case SET_ACTIVE_RIDDLE:{
				// console.log('current logo', action.payload.riddle);
				const riddle = Object.assign({}, action.payload.riddle);
				return Object.assign({}, state, {activeLogo: riddle}, {activeLogoIndex: action.payload.index});
			}

			case DECREMENT_ACTIVE_RIDDLE_POINTS:{
				const amountToSubtract = action.payload.amount;
				const currentActiveLogo = state.activeLogo;
				if (currentActiveLogo.points && currentActiveLogo.points > 0) {
					const pointsAfterSubtraction = currentActiveLogo.points - amountToSubtract;
					const newRiddlePoints = pointsAfterSubtraction > 0 ? pointsAfterSubtraction : 0;
					const activeLogo = Object.assign({}, currentActiveLogo, {points: newRiddlePoints});
					return Object.assign({},
						state,
						{activeLogo});
				} else {
					return state
				}
			}

			case RESET_SCREEN_AFTER_LOGOUT:{
				return Object.assign({}, defaultState, { screen: state.screen })
			}

			case UPDATE_ACTIVE_LOGO_WITH_HINT:{
				const hintKey = action.payload.hintKey;
				const value = action.payload.value;

				const activeLogo = Object.assign({}, state.activeLogo, {[hintKey]: value});

				const returnState = Object.assign({}, state, {activeLogo});

				return returnState
			}

			default:
				return state;
		}
	} catch(error){
		addReducerParametersToError(error, "error_screen_reducer", action, state);
		throw error
	}
}
